import styled from '@emotion/styled';

export const ContactDetailsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  padding-bottom: 0.5rem;
`;

export const CheckBoxWrapper = styled('div')`
  display: inline-flex;
  gap: 0.5rem;
  padding: 0.5rem 1rem 0 1rem;
`;
